export default "__VITE_ASSET__CdESjnGC__"